import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../App";
import Button from "../button/Button";

// components
import VideoModal from "../video-modal/VideoModal";

// css
import "./NoticePage.css";

import checkmarkImg from "../../assets/images/checkmark-white.png";

const NoticePage = () => {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_states.json`;
  const skuUrl = process.env.REACT_APP_SKU_URL;

  // state selection
  const [modal, setModal] = useState(false); // Controls the modal show/hide functionality with a simple boolean.
  const [stateOption, setStateOption] = useState("Please Select State");
  const [fetchedData, setFetchedData] = useState("");
  const [isApproved, setIsApproved] = useState("");
  const [litFileName, setLitFileName] = useState("");
  const [hasStateSpecLit, setHasStateSpecLit] = useState("");
  const [stateId, setStateId] = useState("");
  const [stateKey, setStateKey] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  // console.log(`state Option: ${stateOption}`);
  // console.log(`is approved: ${isApproved}`);
  // console.log(`lit File Name: ${litFileName}`);
  // console.log(`has state specific lite: ${hasStateSpecLit}`);
  // console.log(`state ID: ${stateId}`);
  // console.log(`state Key: ${stateKey}`);

  async function fetchData() {
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();
    // console.log(data);
    setFetchedData(data.product.state);
  }

  // run the data fetch on load
  useEffect(() => {
    fetchData();
  }, []);

  // context taken from app
  const { dispatch } = useContext(AuthContext);

  // state object we are using for auth
  const initialState = {
    stateSelection: "",
    isSubmitting: false,
    errorMessage: null,
  };

  // this runs on the close button on the modal. We have to set modalFitem to ('') or else the video will keep playing when you close the modal.
  function renderClose() {
    setModal(false);
  }

  const [data, setData] = useState(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (stateOption !== "Please Select State") {
      sessionStorage.setItem("stateSelection", stateOption);
      sessionStorage.setItem("accepted", true);
      sessionStorage.setItem("isStateApproved", isApproved);
      sessionStorage.setItem("litFileName", litFileName);
      sessionStorage.setItem("stateSpecificLit", hasStateSpecLit);
      sessionStorage.setItem("stateId", stateId);
      sessionStorage.setItem("statekey", stateKey);
      dispatch({ type: "LOGIN", payload: stateOption });
    } else {
      setData({
        ...data,
        isSubmitting: false,
        errorMessage: "Please select a state from the dropdown above",
      });
    }
  };

  const handleStateClick = (e, app, litFile, sName, sKey, sId, specLit) => {
    e.preventDefault();
    // console.log("clicked");
    setIsApproved(app);
    setLitFileName(litFile);
    setStateOption(sName);
    setStateKey(sKey);
    setStateId(sId);
    setHasStateSpecLit(specLit);
    if (app === "True") {
      setData({
        ...data,
        isSubmitting: false,
        errorMessage: "",
      });
    }
    if (app === "False") {
      setData({
        ...data,
        isSubmitting: false,
        errorMessage: "Sorry, this state is not approved.",
      });
    }
  };

  return (
    <>
      <div className="notice-page-container">
        <div className="important-notice">
          <h3 className="font-bold mb-3">IMPORTANT NOTICE</h3>
          <p className="mb-3 font-light">
            This site and the materials herein are directed only to certain
            types of investors and to persons in jurisdictions where shares of
            common stock of StratCap Digital Infrastructure REIT, Inc. are
            authorized for offer or sale.
          </p>
          <p className="mb-3 font-light">
            This website is neither an offer to sell nor a solicitation of an
            offer to buy the securities described in the StratCap Digital
            Infrastructure REIT, Inc. prospectus. An offering is made only by a
            prospectus to individuals who meet minimum suitability requirements.
            This website must be read in conjunction with a prospectus in order
            to understand fully all the implications and risks of the offering
            of securities to which it relates. Neither the Securities and
            Exchange Commission nor any other regulatory body has approved or
            disapproved of our securities or determined if our prospectus is
            truthful or complete. Neither the Attorney General of the State of
            New York nor the securities division of the office of the Maryland
            attorney general has passed on or endorsed the merits of this
            offering. Any representation to the contrary is a criminal offense.
          </p>
          <div className="mb-3">
            <img src="" alt="" />
            {/* <a
              href={`${skuUrl}SCW0003-WEB`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Prospectus
            </a> */}
            <p
              onClick={() => {
                setModal(true);
              }}
              className="pointer t-underline m-0 d-inline"
            >
              Download Prospectus
            </p>
          </div>
          <p className="mb-3 font-light">
            I acknowledge that (i) I have received the prospectus and (ii)
            either (a) I am a United States resident or (b) I have otherwise
            received authorization from StratCap Digital Infrastructure REIT,
            Inc. or my broker-dealer/registered investment advisor to access the
            contents of this website.
          </p>
          <h4 className="font-semibold mb-2">State of Residence</h4>
          <div class="dropdown">
            <button
              class="dropbtn"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <span>{stateOption}</span> <span>&#9660;</span>
            </button>
            <div
              class={
                showDropdown === true
                  ? "notice-page-dropdown-content-show"
                  : "notice-page-dropdown-content-hide"
              }
            >
              {fetchedData
                ? fetchedData.map((state, i) => {
                    return (
                      <p
                        key={state.state_id}
                        onClick={(e) => {
                          handleStateClick(
                            e,
                            state.is_approved,
                            state.literature_file_name,
                            state.state_name,
                            state.state_key,
                            state.state_id,
                            state.has_state_specific_literature
                          );
                          setShowDropdown(false);
                        }}
                      >
                        {state.state_name}
                      </p>
                    );
                  })
                : null}
            </div>
          </div>
          <p className="mt-2 mb-5 font-light text-xs text-gray-700">
            By selecting a state from the above list, you certify that you are
            resident in that state.
          </p>
          <div className="notice-flex">
            <div className="mb-3">
              {data.errorMessage && (
                <p className="form-error">{data.errorMessage}</p>
              )}
            </div>
            <div className="flex items-center w-full justify-between md:justify-end">
              <a
                className="underline underline-offset-2 mr-0 md:mr-7"
                href="https://stratcap.com/"
              >
                Leave Site
              </a>
              <form onSubmit={handleSubmit}>
                {/* <button type="submit">I agree to the terms</button> */}
                {isApproved === "False" ? (
                  <Button type="submit" disabled={true} color="bg-hmcGold">
                    I agree to the terms{" "}
                    <img
                      src={checkmarkImg}
                      alt="checkmark"
                      className="inline w-[22px] pl-[5px]"
                    />
                  </Button>
                ) : (
                  <Button type="submit" disabled={false} color="bg-hmcGold">
                    I agree to the terms{" "}
                    <img
                      src={checkmarkImg}
                      alt="checkmark"
                      className="inline w-[22px] pl-[5px]"
                    />
                  </Button>
                )}
                {/* {isApproved === "False" ? (
                  <Button
                    type="submit"
                    text="I agree to the terms"
                    dis="true"
                    img="true"
                  />
                ) : (
                  <Button img="true" type="submit" text="I agree to the terms" />
                )} */}
              </form>
            </div>
          </div>
        </div>
        <VideoModal
          show={modal}
          close={renderClose}
          notHostedLink={`${skuUrl}DIR0003-WEB`}
          isVideo={"False"}
        />
      </div>
    </>
  );
};

export default NoticePage;
